import { RouterProvider } from 'react-router-dom';
import { router } from './routes';
import PublicClaimForm from './pages/public/PublicClaimForm';

// The public claims subdomain (support.dniprowood.com) serves ONLY the
// Customer Claim Form — no router, no login, no access to the ERP at all.
const isPublicClaimHost = window.location.hostname.startsWith('support.');

const App = () => {
  if (isPublicClaimHost) {
    return <PublicClaimForm />;
  }
  return <RouterProvider router={router} />;
};

export default App;
